module.exports = __webpack_public_path__ + "img/hr-curved-rail-vertical-right-top-backplates.13589cfb.png";